import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import emptyImg from '../../../Assets/icons/empty2.svg';
import logo from '../../../Assets/logo/logo.svg';

const ErrorState = ({ 
  restaurant, 
  name, 
  onRetry, 
  IS_TERRACE, 
  IS_FORNO, 
  IS_SHIRO, 
  IS_HARDROCK 
}) => {
  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          pt: 3,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <img
          src={
            IS_TERRACE || IS_FORNO || IS_SHIRO || IS_HARDROCK
              ? restaurant?.Logo
              : logo
          }
          width={70}
          alt="logo"
        />
        <Box
          sx={{
            mt: 2,
            display: 'flex',
            alignItems: 'center',
            columnGap: 2,
            px: 3,
            flexDirection: 'column',
          }}
        >
          <Typography
            sx={{
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              maxWidth: '100%',
              overflow: 'hidden',
            }}
          >
            Make a Reservation at
            <span
              style={{
                textTransform: 'uppercase',
                fontWeight: 700,
              }}
            >
              {' '}
              {name}
            </span>
          </Typography>
          <Typography
            sx={{
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              maxWidth: '100%',
              overflow: 'hidden',
              fontSize: '12px',
              mt: 0.5,
            }}
          >
            Opens from{' '}
            <b>
              {' '}
              {restaurant?.OpenFrom?.substring(0, 8) || '--'}
            </b>
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          mt: 10,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div style={{ display: 'grid', placeContent: 'center' }}>
          <img src={emptyImg} width={200} height={200} alt="empty" />
        </div>
        <Typography
          sx={{
            textAlign: 'center',
            fontWeight: 700,
            fontSize: '20px',
            mt: 4,
            px: 3,
            fontFamily: 'optima',
          }}
        >
          Unable to retrieve reservation details
        </Typography>
        <Typography
          sx={{
            color: '#333333b7',
            textAlign: 'center',
            mx: 3,
            mt: 1,
          }}
        >
          Kindly check your browser and refresh
        </Typography>
        <Button
          variant="contained"
          sx={{
            mt: 4,
            borderRadius: '8px',
            width: '150px',
            height: '45px',
          }}
          onClick={onRetry}
        >
          Retry
        </Button>
      </Box>
    </Box>
  );
};

export default ErrorState;
